export default {
  login: {
    title: 'سائن ان',
    username: 'صارف کا نام',
    phone: 'فون نمبر',
    phoneCode: 'کوڈ',
    email: 'ای میل',
    password: 'پاس ورڈ',
    captcha: 'کیپچا',
    loading: 'لوڈ ہو رہا ہے...',
    rememberMe: 'مجھے یاد رکھیں',
    forgotPassword: 'پاس ورڈ بھول گئے؟',
    loginButton: 'سائن ان',
    contactUs: 'ہم سے رابطہ کریں？',
    noAccount: 'اکاؤنٹ نہیں ہے؟',
    registerNow: 'سائن اپ',
    or: 'یا',
    orSignInWith: 'یا اس کے ساتھ سائن ان کریں',
    methodUsername: 'صارف نام',
    methodPhone: 'فون',
    methodEmail: 'ای میل',
    usernameRequired: 'صارف کا نام ضروری ہے',
    phoneRequired: 'فون نمبر ضروری ہے',
    emailRequired: 'ای میل ضروری ہے',
    passwordRequired: 'پاس ورڈ ضروری ہے',
    captchaRequired: 'کیپچا ضروری ہے',
    resetPassword: 'پاس ورڈ ری سیٹ کریں',
    resetStep1Hint: 'تصدیقی کوڈ حاصل کرنے کے لیے اپنا فون نمبر یا ای میل درج کریں۔',
    useEmailInstead: 'ای میل استعمال کریں',
    usePhoneInstead: 'فون استعمال کریں',
    sendCode: 'کوڈ بھیجیں',
    resetStep2Hint: 'تصدیقی کوڈ بھیج دیا گیا ہے',
    verificationCode: 'تصدیقی کوڈ',
    verificationCodeRequired: 'تصدیقی کوڈ ضروری ہے',
    resendIn: 'دوبارہ بھیجیں',
    resendCode: 'کوڈ دوبارہ بھیجیں',
    verify: 'تصدیق کریں',
    resetStep3Hint: 'اپنا نیا پاس ورڈ سیٹ کریں۔',
    newPassword: 'نیا پاس ورڈ',
    confirmPassword: 'پاس ورڈ کی تصدیق کریں',
    passwordMinLength: 'پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے',
    confirmPasswordRequired: 'براہ کرم اپنے پاس ورڈ کی تصدیق کریں',
    passwordMismatch: 'پاس ورڈ مماثل نہیں ہیں',
    resetPasswordBtn: 'پاس ورڈ ری سیٹ کریں',
    back: 'واپس',
    // Format validation
    emailFormat: 'ای میل کی شکل غلط ہے',
    // Toast messages
    loginSuccess: 'لاگ ان کامیاب',
    loginFailed: 'لاگ ان ناکام',
    signInWithGoogle: 'Google+ کے ساتھ سائن ان کریں',
    codeSent: 'تصدیقی کوڈ بھیج دیا گیا',
    sendCodeFailed: 'کوڈ بھیجنے میں ناکامی',
    invalidCode: 'تصدیقی کوڈ غلط ہے',
    resetSuccess: 'پاس ورڈ کامیابی سے دوبارہ ترتیب دیا گیا',
    resetFailed: 'پاس ورڈ دوبارہ ترتیب دینے میں ناکامی'
  }
};
